import React from 'react';

export default function Label({ small, id, children }) {
    return <label className={`block ${small ? 'text-xs text-grey-500' : ''}`} htmlFor={id}>
        { children }
    </label>
}
